import React from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as Blackclose } from "../../assets/images/black-close.svg";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  updateShowSigninOverlayFlag,
  updateShowRegisterOverlayFlag,
} from "../../store/home/home.actions";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      updateShowRegisterOverlayFlag,
      updateShowSigninOverlayFlag,
    },
    dispatch
  ),
});

class SigninRegisterModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hideModal}
        backdrop="static"
        keyboard={false}
        centered
        id="signinregister-modal"
      >
        <div className="modal-close">
          <Blackclose className="closeicon" onClick={this.props.hideModal} />
        </div>
        <div className="register-modal">
          <img
            src={require("../../assets/images/electrified-black.png")}
            alt="logo"
            className="black-logo"
          ></img>
          <p>Sign in or Register to add favorites and comments</p>
          <button
            onClick={() => {
              this.props.updateShowRegisterOverlayFlag();
              this.props.hideModal();
            }}
            className="register-btn"
          >
            Register
          </button>
          <button
            onClick={() => {
              this.props.updateShowSigninOverlayFlag();
              this.props.hideModal();
            }}
            className="register-btn"
            id="signin-btn"
          >
            Sign in
          </button>
        </div>
      </Modal>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SigninRegisterModal);
